<div class="stockwarehousewrapper"> 
  <div class="homecomponent">
    <div class="text-heading-3 important-content">Important actions</div>
    <div >
      <ul class="nav nav-pills mb-3" id="homepills" role="tablist">
        <li class="nav-item" role="presentation">
          <button class="nav-link" [class.active]="activeTab === 'alerts'" (click)="setActiveTabs('alerts')" type="button" role="tab" aria-controls="pills-home" aria-selected="false">
            <div><img src="../../../assets/images/storelist/alerts.svg" alt="alerts"></div>
            <div class="headerName text-heading-6">Alerts & Notifications</div>
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link" [class.active]="activeTab === 'stores'" (click)="setActiveTabs('stores')" type="button" role="tab" aria-controls="pills-profile" aria-selected="false">
           <div><img src="../../../assets/images/storelist/stores.svg" alt="stores"></div> 
           <div class="headerName text-heading-6">Stores</div>
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link" [class.active]="activeTab === 'warehouse'" (click)="setActiveTabs('warehouse')" type="button" role="tab" aria-controls="pills-contact" aria-selected="false">
           <div><img src="../../../assets/images/storelist/warehouse.svg"></div>
           <div class="headerName text-heading-6">Warehouse</div>
          </button>
        </li>
      </ul>
     <div class="tab-content" id="pills-tabContent">
       <div class="tab-pane fade" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
          <app-alerts-notify></app-alerts-notify>
       </div>
       <div class="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
          <app-stores-list></app-stores-list>
       </div>
       <div class="tab-pane fade show active" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab">
        <div class="warehousewrapper" >
          <div class="stockdetail text-heading-3">Stocks at Warehouse</div>
          <button class="export-btn addproduct" (click)="openAddProductDialog(warehouseId)">
              <i class="export-icon"></i>
              Add Product
          </button>
        </div>
         <div class="storedetailwrapper">
          <!-- active -->
          <a [routerLink]="['/home/warehouses/4/implants/active']">
          <ng-container> 
           <div class="storewrapper">
             <div class="hrline"><hr /></div> 
             <img class="stockimg" src="../../../../assets/images/storelist/implants.svg" alt="implants">
             <div class="">
               <div class="stockslist">
                 <div class="stocksname text-para">Active Implants</div>   
               </div>
               <div class="stocksection">
                <div class="stockcount">
                  <div class="stock-value text-heading-3">{{ stockNames.active_stocks }}</div>
                </div>
                <div class="downloadimg"> 
                  <div class="downloadcontent text-button">Download<img class="downloadimgcontent" src="../../../../assets/images/storelist/download.svg" alt="download"></div>
                </div>
               </div>
             </div>
            </div> 
          </ng-container>
        </a>
    
          <!-- expiring -->
          <a [routerLink]="['/home/warehouses/4/implants/expiring']">
          <ng-container>
            <div class="storewrapper">
              <div class="hrline"><hr /></div> 
              <img class="stockimg" src="../../../../assets/images/storelist/expiring.svg" alt="implants">
              <div class="">
                <div class="stockslist">
                  <div class="stocksname text-para">Expiring in 30days</div>   
                </div>
                <div class="stocksection">
                 <div class="stockcount">
                   <div class="stock-value text-heading-3">{{ stockNames.expiring_stocks }}</div>
                 </div>
                 <div class="downloadimg"> 
                   <div class="downloadcontent text-button">Download<img class="downloadimgcontent" src="../../../../assets/images/storelist/download.svg" alt="download"></div>
                 </div>
                </div>
              </div>
             </div> 
           </ng-container>
          </a>
    
          <!-- expired -->
          <a [routerLink]="['/home/warehouses/4/implants/expired']">
          <ng-container>
            <div class="storewrapper">
              <div class="hrline"><hr /></div> 
              <img class="stockimg" src="../../../../assets/images/storelist/expired.svg" alt="implants">
              <div class="">
                <div class="stockslist">
                  <div class="stocksname text-para">Expired Implants</div>   
                </div>
                <div class="stocksection">
                 <div class="stockcount">
                   <div class="stock-value text-heading-3">{{ stockNames.expired_stocks }}</div>
                 </div>
                 <div class="downloadimg"> 
                   <div class="downloadcontent text-button">Download<img class="downloadimgcontent" src="../../../../assets/images/storelist/download.svg" alt="download"></div>
                 </div>
                </div>
              </div>
             </div> 
           </ng-container>
          </a>
    
         </div>
         <div class="d-flex w-100 gap-3 mt-3">
           <div class="w-50 app-border-grey p-3">
            <div class="text-heading-4 text-dark mb-4">Shipment Summary</div>
            <app-shipment-summary></app-shipment-summary>
           </div>
           <div class="w-50 app-border-grey p-3">
              <div class="text-heading-4 text-dark mb-4">Category wise stocks in warehouse</div>
              <app-category-stocks></app-category-stocks>
             </div>
         </div>
       </div>
     </div>
    </div>
 </div>
    
  </div>